import VueRouter from 'vue-router';
import Vue from 'vue';
import outlet from './route-components/outlet';
import onAccount from './route-components/onaccount';
import myaccount from './route-components/myaccount';
import device from './route-components/device';
import supplier from './route-components/franchise-inventory/supplier';
import stockCheck from './route-components/franchise-inventory/stock-check';
import stockReceive from './route-components/franchise-inventory/stock-receive';
import stockReturn from './route-components/franchise-inventory/stock-return';
import stockTransfer from './route-components/franchise-inventory/stock-transfer';
import attendantTagging from './route-components/attendanttaging';
import attendantSession from './route-components/attendantsession';
import distributor from './route-components/franchise-inventory/distributor';
import customerEngagement from './route-components/customerengagement';
import gamificationQuota from './route-components/gamificationquota';

const routeComponents = {
    outlet,
    myaccount,
    device,
    supplier,
    stockCheck,
    stockReceive,
    stockReturn,
    onAccount,
    stockTransfer,
    attendantTagging,
    attendantSession,
    distributor,
    customerEngagement,
    gamificationQuota,
};

module.exports = function(routeKey) {
    Vue.use(VueRouter);

    const routes = routeComponents[routeKey];
    const router = new VueRouter({
        routes,
        linkActiveClass: 'active',
    });

    return router;
};
